import { Component } from '@angular/core';

@Component({
    selector: 'app',
    templateUrl: './app.component.html',
})
export class AppComponent {
    ngOnInit() {

    };
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts